(function(app, ng) {
    app.component("stateNavigation", {
        templateUrl: "/App/States/Root/Navbar/StateNavigation/state.navigation.html",
        controller: pageNavigationCtrl
    });

    pageNavigationCtrl.$inject = ["$scope", "searchService", "$mdDialog", "$state", "accessTokenService"];
    function pageNavigationCtrl($scope, searchService, $mdDialog, $state, accessTokenService) {
        var $ctrl = this;

        if (accessTokenService.hasAdminAccess()) {
            $ctrl.isAdmin = true;
        }
        //$ctrl.$onInit = () => {
        //    if($state.current.name === "Root.Carriers") {
        //        $ctrl.activeLink = "Carriers";
        //    } else if ($state.current.name === "Root.Policies.List") {
        //        $ctrl.activeLink = "Policies";
        //    }
        //};

        $ctrl.uploadFile = function($event) {
            $mdDialog.show({
                controller: "fileUploadCtrl",
                templateUrl: "/App/States/Modals/FileUpload/file.upload.html",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                fullscreen: false
            });
        };

        //$ctrl.navigate = function(target) {
        //    $ctrl.activeLink = target;
        //    if (target === "Carriers") {
        //        $state.go("Root.Carriers");
        //    } else if (target === "Policies") {
        //        $state.go("Root.Policies.List", { search: searchService.getTerm() || null });
        //    }
        //};

        $ctrl.createFileProcessorTrack = ($event) => {
            $mdDialog.show({
                controller: "fileProcessorTrackCtrl",
                templateUrl: "/App/States/Modals/FileProcessorTrack/file.processor.track.html",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                fullscreen: false
            });
        };

        //
        // Event emitted from the searchbar. Used to unselect
        // the current active link.
        //
        //$scope.$on("searching", () => {
        //    $ctrl.activeLink = "Policies";
        //});
    }
})(window.app, window.angular);